import {httpApiV3, useVzFetch} from '~/composables/useVzFetch';
import {PublicReview} from '~/types/types';

export function getReviews() {
  return useVzFetch(
    `${httpApiV3}/content/user-reviews`, 
    { method: 'GET' }
  ) as Promise<PublicReview[]>
}